<div id="home-2" class="page-layout simple">
    <div class="content p-4">
        <div fxLayout="column" fxLayoutAlign="center">
            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <div class="course" fxFlex="100" [ngClass]="'web'" [@animate]="{value:'*',params:{y:'100%'}}">
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let item of unit; let j = index" [expanded]="j == 0 ? true : false" class="course-content mb-16">

                            <mat-expansion-panel-header class="header" fxLayout="row" fxLayoutAlign="center center"
                                 [ngClass]="'web-bg'">
                                <div class="length" fxLayout="row" fxLayoutAlign="center center">
                                    <div class="min" *ngFor="let fcl of filterFclPrice | unitfilter: [item, true]">
                                        OCEAN FREIGHT : {{fcl.amount| number:(fcl.currency.code == 'VND' ? '1.0-0' : '1.2-2')}} {{fcl.currency.code}} per {{fcl.unit.code}}
                                    </div>
                                    <div class="min" *ngIf="item == 'SPT'">
                                        SHIPMENT
                                    </div>
                                </div>
                            </mat-expansion-panel-header>
                            <div *ngFor="let pay of paymentCenter" class="mt-24">
                                <span  style="font-weight: bolder">Local charge in {{pay}}</span>
                                <div style="overflow: auto;">
                                    <table class="simple">
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>Price</th>
                                                <th>Unit</th>
                                                <th style="text-align: right; padding-right: 16px">Amount</th>
                                                <th>Tax</th>
                                                <th>Currency</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="price-row" *ngFor="let fcl of filterFclPrice | unitfilter: [item, false, pay]; let i = index">
                                                <td>{{i + 1}}</td>
                                                <td>{{fcl.price.name}}</td>
                                                <td>{{fcl.unit.code}}</td>
                                                <td style="text-align: right; padding-right: 16px">{{fcl.amount | number:(fcl.currency.code == 'VND' ? '1.0-0' : '1.2-2')}}</td>
                                                <td>{{fcl.tax | number:0}}%</td>
                                                <td>{{fcl.currency.code}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>


        <!--
        <form name="unitForm" [formGroup]="unitForm">
            <div fxLayout="row wrap" fxLayoutAlign="center">
              <mat-form-field appearance="outline" 
                class="pr-8" fxFlex="100" fxFlex.gt-xs="50">
                <mat-label>Unit</mat-label>
                <mat-select formControlName="unit" >
                    <mat-option [value]="0">All</mat-option>
                    <mat-option *ngFor="let item of unit"
                                [value]="item">
                        {{item}}
                    </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" 
                class="pr-8" fxFlex="100" fxFlex.gt-xs="50">
                <mat-label>Payment center</mat-label>
                <mat-select formControlName="paymentCenter">
                    <mat-option [value]="0">All</mat-option>
                    <mat-option *ngFor="let item of paymentCenter"
                                [value]="item">
                        {{item}}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
        </form>
        <table class="simple">
            <thead>
                <tr>
                    <th class="w-60">ID</th>
                    <th class="w-120">Price</th>
                    <th class="w-120">Unit</th>
                    <th class="w-100">Amount</th>
                    <th class="w-60">Tax</th>
                    <th class="w-100">Currency</th>
                    <th class="w-120">Payment Center</th>
                </tr>
            </thead>
            <tbody>
                <tr class="price-row" *ngFor="let item of filterFclPrice">
                    <td>{{item.id}}</td>
                    <td>{{item.price.name}}</td>
                    <td>{{item.unit.code}}</td>
                    <td>{{item.amount | number:(item.currency.code == 'VND' ? '1.0-0' : '1.2-2')}}</td>
                    <td>{{item.tax | number:0}}</td>
                    <td>{{item.currency.code}}</td>
                    <td>{{item.payment_center}}</td>
                </tr>
            </tbody>
        </table>
        
        -->
    </div>
</div>
